import { AxiosRequestConfig } from 'axios';
import { useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import InputFile from '../../components/InputFile/InputFile';
import PageTitle from '../../components/PageTitle';
import api from '../../services/api';
import { DownloadOrdersReport } from '../../services/csvReport';
import Style from "./EnterpriseStyle";

export default function Enterprise(props) {
  const enterpriseId = props.match.params.enterpriseId;

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [uploadingFile, setUploadingFile] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);

  async function SendSpreadsheet(file) {
    try {
      console.log("Enviando spreadsheet");
      setSuccessMessage("");
      setErrorMessage("");
      const options: AxiosRequestConfig = {};
      const formData = new FormData();

      formData.append("users", file, file.name);
      formData.append("enterpriseId", enterpriseId);
      console.log("Enviando spreadsheet");
      options.onUploadProgress = progressEvent => {
        const { loaded, total } = progressEvent;
        const percentage = Math.floor(loaded * 100 / total);
        setUploadPercentage(percentage);
        console.log(`${loaded}kb de ${total}kb | ${percentage}% carregados`);
      }


      setUploadingFile(true);
      const request = api.put(`/users/spreadsheet`, formData, options);
      const result = await request;
      if (result.data.success)
        setSuccessMessage("Planilha enviada com sucesso!");
      else
        setErrorMessage(result.data?.message ?? "Não foi possível criar usuários");
    }
    catch (error: any) {
      setErrorMessage(error?.response?.data?.message);
      console.error(error);
    }
    finally {
      setUploadingFile(false);
    }
  }

  function ChangeSpreadsheet(event) {
    const file = event.target.files[0];
    SendSpreadsheet(file);
    event.target.value = null;
  }

  return (
    <Style>
      <PageTitle title="Empreendimentos" />
      {errorMessage !== "" && <p className="alert alert-error">Erro: {errorMessage}</p>}
      {successMessage !== "" && <p className="alert alert-info">{successMessage}</p>}
      {uploadingFile &&
        <div>
          <label htmlFor="file">Progresso do Upload:</label>
          <ProgressBar variant="success" now={uploadPercentage} label={`${uploadPercentage}%`} />
        </div>
      }
      <div id="options">
        <div id="reports">
          <Link className="btn btn-secondary" to={`/enterprises/${enterpriseId}/tasks`}>Tarefas da Obra</Link>
          <Link className="btn btn-secondary" to={`/enterprises/${enterpriseId}/updates`}>Atualizações da Obra</Link>
          <Link className="btn btn-secondary" to={`/enterprises/${enterpriseId}/info`}>Informações do empreendimento</Link>
          <Link className="btn btn-secondary" to={`/enterprises/${enterpriseId}/blocks`}>Blocos</Link>
          <Link className="btn btn-secondary" to={`/enterprises/${enterpriseId}/ratings`}>Avaliação dos usuários</Link>
          <Link className="btn btn-secondary" to={`/enterprises/${enterpriseId}/report`}>Relatório de Itens</Link>
          <Link className="btn btn-secondary" to={`/enterprises/${enterpriseId}/paymentOptions`}>Opções de Pagamento</Link>
          <Link className="btn btn-secondary" to={`/enterprises/${enterpriseId}/clickSign`}>Integração ClickSign</Link>
        </div>
        <div id="files">
          <InputFile
            id="spreadsheet"
            name="spreadsheet"
            text="Enviar planilha de usuários"
            disabled={false}
            accept=".csv, .xls, .xml, .ods"
            onChange={ChangeSpreadsheet}
          />
          <label className="report-button" onClick={() => DownloadOrdersReport(props.match.params.enterpriseId)}>Baixar relatório de pedidos</label>
        </div>
      </div>
    </Style>

  )
}
